export default "__VITE_PUBLIC_ASSET__ee453304__"